/**
 * How often a contribution is made, in months.
 *
 * The control that used to live here — four Ant Design radio buttons in a
 * joined bar, every one of them periwinkle-on-periwinkle with the selected
 * one solid accent — is gone; the field is drawn with the product's own
 * SegmentedControl in GoalAmountFormInputs, which is what the rest of the
 * app uses for a small fixed single-select. The Formik variant beside it had
 * no callers.
 *
 * The enum stays: it is the wire format. The API takes the cadence as a
 * number of months, so Quarterly is 3 and these values are not cosmetic.
 */
export enum FrequencyInMonths {
  Monthly = 1,
  Quarterly = 3,
  SemiAnnually = 6,
  Annually = 12,
}
